import { Component, OnInit } from '@angular/core';
import { SUCCESS_PAGE_TEXT, ISTATACARD } from 'src/app/config/app-settings.config';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { getCookie } from "src/app/utilities/utilities.file";
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-success-page',
  templateUrl: './success-page.component.html',
  styleUrls: ['./success-page.component.scss']
})
export class SuccessPageComponent implements OnInit {
  success_text: any;
  TATACARD = ISTATACARD;
  applicantApplicationNumber: any;
  mobileNumber: any;
  emailId: any;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  existingMessage:any;
  isShortLeadThankYou: any;
  shortLeadVerbiage: any;

  constructor(
    private sharedService: SharedServiceService,
    private themeService: ThemeService
    ) { 
    this.partnerCode = this.themeService.partnerCode;
  }

  ngOnInit() {
    // (document.documentElement || document.body).scrollTop = 0;
    document.getElementById('sbicard')?document.getElementById('sbicard').scrollTop=0:(document.documentElement || document.body).scrollTop = 0;
    this.success_text = SUCCESS_PAGE_TEXT
    this.applicantApplicationNumber = this.sharedService.applicantApplicationNumber
    this.existingMessage = this.sharedService.existingMessage;
    this.isShortLeadThankYou = getCookie('isShortLeadThankYou');
    this.shortLeadVerbiage = "You appear to have applied recently. We do not allow you to submit multiple applications to prevent numerous enquiries on your bureau history.";
    this.sharedService.sslEnabled = false;
    //this.mobileNumber = this.sharedService.trackApplicationResponse.eapplyApplicantDetails && this.sharedService.trackApplicationResponse.eapplyApplicantDetails.mobileNumber ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.mobileNumber : '';
    //this.emailId = this.sharedService.trackApplicationResponse.eapplyApplicantDetails && this.sharedService.trackApplicationResponse.eapplyApplicantDetails.personalEmailId ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.personalEmailId : '';
  }

}
